import * as React from 'react';

const SvgIconSearch = (props) => (
  <svg viewBox="0 0 10 12" fill="none" fillOpacity="0" xmlns="http://www.w3.org/2000/svg" data-icon="1" {...props}>
    <path d="m7.5 8.667 2 2M.835 5.334a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z" stroke="#fff" />
  </svg>
);

export default SvgIconSearch;
